export default {
  loading: (state) => state.loading,
  items: (state) => state.items,
  search: (state) => state.search,
  sort: (state) => state.sort,
  page: (state) => state.page,
  total: (state) => state.total,
  totalAll: (state) => state.totalAll,
}
